import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import {NotificationService} from "./notification.service";

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(private injector: Injector) { }

  /**
   * Maneja errores de forma global
   * @param error Error a manejar
   */
  handleError(error: any): void {
    const notification = this.injector.get(NotificationService);
    const router = this.injector.get(Router);

    // Error HTTP
    if (error instanceof HttpErrorResponse) {
      this.handleHttpError(error, notification, router);
    }
    // Error de JavaScript/Runtime
    else {
      this.handleClientError(error, notification);
    }

    // Logging (opcional - enviar a servicio de tracking)
    console.error('Error global:', error);
  }

  /**
   * Maneja errores HTTP específicos
   * @param error Error HTTP
   * @param notification Servicio de notificaciones
   * @param router Router de Angular
   */
  private handleHttpError(
    error: HttpErrorResponse,
    notification: NotificationService,
    router: Router
  ): void {
    switch (error.status) {
      case 0:
        notification.error('Error de conexión', 'No se puede conectar al servidor');
        break;
      case 401:
        notification.error('No autorizado', 'Su sesión ha expirado');
        router.navigate(['/auth/login']);
        break;
      case 403:
        notification.error('Prohibido', 'No tiene permisos para esta acción');
        break;
      case 404:
        notification.error('No encontrado', 'Recurso no disponible');
        break;
      case 500:
        notification.error('Error del servidor', 'Error interno del servidor');
        break;
      default:
        notification.error('Error', error.error?.message || 'Error desconocido');
    }
  }

  /**
   * Maneja errores de cliente/JavaScript
   * @param error Error de cliente
   * @param notification Servicio de notificaciones
   */
  private handleClientError(error: any, notification: NotificationService): void {
    notification.error('Error de aplicación', 'Ha ocurrido un error inesperado');
  }
}
